export default __webpack_public_path__ + "static/media/bg2.29d8d2b9.png";